import cx from 'classnames';
import * as QRCode from 'qrcode';
import { useCallback, useEffect, useState } from 'react';

import { CLARITY_MASK_PROPS } from 'constants/clarity.constants';

type Props = {
  data: any;
  className?: string;
  innerClassName?: string;
  imageClassName?: string;
  title?: string;
  showDownload?: boolean;
  downloadLabel?: string;
  onGenerated?: (url: string) => void;
};

export const QrCode: React.FC<Props> = ({
  data,
  className,
  innerClassName,
  imageClassName = 'tw-m-auto',
  title,
  showDownload,
  downloadLabel,
  onGenerated,
}) => {
  const [qrCode, setQrCode] = useState<string>();
  const [loading, setLoading] = useState<boolean | null>(null);
  const [error, setError] = useState(false);

  const generateQrCode = useCallback(
    async (data: any) => {
      if (!loading && !error && !qrCode && data) {
        try {
          setLoading(true);
          const stringifiedData =
            typeof data === 'string' ? data : JSON.stringify(data);
          const qrCodeUrl = await QRCode.toDataURL(stringifiedData);
          setQrCode(qrCodeUrl);
          onGenerated?.(qrCodeUrl);
        } catch (e) {
          setError(!!e);
        } finally {
          setLoading(false);
        }
      }
    },
    [loading, error, qrCode, onGenerated],
  );

  useEffect(() => {
    generateQrCode(data);
  }, [data, generateQrCode]);

  if (loading !== false || error) {
    return null;
  }

  return (
    <div className={cx('tw-flex tw-flex-col tw-items-center', className)}>
      <div className={cx('tw-border tw-px-2 tw-bg-white', innerClassName)}>
        <img
          className={imageClassName}
          src={qrCode}
          alt="qr"
          {...CLARITY_MASK_PROPS}
        />
        {title && (
          <div className="tw-text-center tw-font-bold tw-mb-4">{title}</div>
        )}
      </div>
      {showDownload && qrCode && (
        <a
          href={qrCode}
          download="qr.png"
          className="tw-text-xs tw-text-link tw-mt-1"
        >
          {downloadLabel}
        </a>
      )}
    </div>
  );
};
